/** How long ago a truck last reported, for the panel: "just now", "4 min ago", "3 h ago", "2 days ago". */
export function truckAgeLabel(deviceTime: string, now: Date): string {
  const seconds = Math.max(0, Math.round((now.getTime() - new Date(deviceTime).getTime()) / 1000));
  if (seconds < 30) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${Math.max(1, minutes)} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `${hours} h ago`;
  return `${Math.round(hours / 24)} days ago`;
}
